import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { loginWithGoogle } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const params = new URLSearchParams(hash.replace('#', ''));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/login', { replace: true });
      return;
    }

    loginWithGoogle(sessionId)
      .then((data) => {
        if (data.needs_phone) {
          navigate('/account/complete-profile', { replace: true, state: { user: data } });
        } else {
          navigate('/account', { replace: true, state: { user: data } });
        }
      })
      .catch(() => {
        navigate('/login', { replace: true });
      });
  }, [location, navigate, loginWithGoogle]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-[#D4AF37] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-white/50 text-sm font-sans">Signing you in...</p>
      </div>
    </div>
  );
}
